import { Create } from "react-admin";

const CreateFormContainer = Create;

export default CreateFormContainer;

export interface CreateFormContainerProps {}
